/**
 * For now, because there is no need to differentiate between
 * formsort flows, we will just use the presence of the "lastFlowLabel"
 * attribute to detect a user who went through the formsort survey.
 *
 * All survey attributes, including the "lastFlowLabel", won't be set
 * in the onboardingInformation unless the user completed the entire
 * survey.
 *
 * @param {object} user
 * @returns {boolean} - Whether the user looks to have completed the
 * formsort survey.
 */
export const hasQuizOnboardingData = (user) => {
  return (
    !!user?.gameProfile?.onboardingInformation?.lastFlowLabel &&
    !!user?.gameProfile?.onboardingInformation?.firstName
  );
};
